module.exports = "/fonts/fa-brands-400.woff2?b9df8fe0faf79eb4f60bf3c42f2ba249";